export default __webpack_public_path__ + "static/media/img-guide-gt-popup-1-be_fr.acb37660.png";